import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-activation-success',
  imports: [RouterLink],
  templateUrl: './activation-success.html',
  styleUrl: './activation-success.scss'
})
export class ActivationSuccess {

}
